// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css'; 
import App from './app.js';

const root = createRoot(document.getElementById('root'));
root.render(<App />);